import {enqueueSnackbar} from 'notistack';
import './styles.css';

export default function errorToast(message) {
    return enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        className: 'snackbar-custom',
    })
}
